<template>
	<div>
		<action-sidebar
			title=""
			:value="true"
			:width="400"
			@close-modal="closeModal"
		>
			<div class="wrapper">
				<h2
					class="modal-title"
					:style="`color:${$appColors.primary}`"
				>Íconos</h2>
				<icons-grid-component :icons="icons"/>
				<div class="modal-btn-container">
					<app-button
						class="close-btn"
						:style="`background-color:${$appColors.error}`"
						text="Cerrar"
						@click="closeModal"
					/>
					<app-button
						class="close-btn"
						text="Guardar"
						@click="selectIcon"
					/>
				</div>
			</div>
		</action-sidebar>
	</div>
</template>
<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appButton from '@/components/shared/app-button';
import iconsGridComponent from '@/components/shared/icons/icons-grid-components';
import { mapState } from 'vuex';

function created() {
	this.$store.dispatch('icon/load');
}

function closeModal() {
	this.$router.back();
}

function selectIcon() {
	this.showNotification('Ícono seleccionado', 'success');
	this.closeModal();
}

export default {
	name: 'icon-modal',
	components: {
		actionSidebar,
		appButton,
		iconsGridComponent,
	},
	computed: {
		...mapState('icon', {
			icons: state => state.icon.list,
		}),
	},
	created,
	methods: {
		closeModal,
		selectIcon,
	},
};
</script>
<style lang="scss" scoped>
.wrapper {
	background-color: color(gray-light);
}
.modal-title {
	border-bottom: 1px solid color(gray-slider);
	font-family: font(bold);
	font-size: size(xlarge);
	margin: 0px 20px 20px;
	padding-bottom: 12px;
	padding-top: 30px;
}
.modal-btn-container {
	background-color: white;
	bottom: 0;
	display: flex;
	justify-content: center;
	padding: 20px;
	position: fixed;
	width: 100%;
	
	.close-btn {
		border-radius: 5px;
		color: white;
		margin: 0 7px;
		padding: 5px 30px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/icons/icon-modal.vue